module.exports = __webpack_public_path__ + "img/cmr.5799ad4c.svg";